'use strict';
var $ = require('jquery');
var urls = require('../utils/urls');

var ajaxStatusConfig = {
    STATUS_GONE: 410,
    UNPROCESSABLE: 422,
	NOT_IMPLEMENTED: 501
};

function ajaxGetJson(config){
	return $.ajax({
					url : config.url,
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: config.headers,
					data: getJsonString(config),
					async	: getAsync(config),
					type : 'GET'
			});
}

function ajaxPostJson(config) {
	return $.ajax({
		url : config.url,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		headers: getHeaders(config),
		data: getJsonString(config),
		async	: getAsync(config),
		type : 'POST',
		timeout: config.timeout
	});
}

function getJsonString(config){
	return (typeof config.jsonString !== 'undefined') ? config.jsonString : '';
}

function getAsync(config) {
	if (typeof config.async === 'undefined') {
		return true;
	} else {
		return config.async;
	}
}

function getHeaders(config){
	return (typeof config.headers !== 'undefined') ? config.headers : '';
}

/**
 * Helper method to be used in .fail() handler of jquery AJAX requests
 * Provides generic failure handling and ability to ignore certain codes
 * @param message
 * @param ignoreCodes - optional array of numbers for status codes for which error handling won't be invoked
 * @returns {Function}
 */
function handleError(message, ignoreCodes) {
    return function (jqXHR, status, faf) {
        if (ignoreCodes && ignoreCodes.indexOf(jqXHR.status) > -1) {
            console.log('Skipping processing of error code ' + jqXHR.status);
        } else {
            errorHandler(jqXHR, message);
        }
    };
}

/**
 * Jquery ajax error handler
 */
function errorHandler(jqXHR, message) {
    console.error('ajaxHandler.errorHandler '+jqXHR.status+' '+ message);
    if (jqXHR.status === ajaxStatusConfig.UNPROCESSABLE) {
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.STATUS_GONE) {
        urls.navigateToUrl(process.env.contextRoot+'/session-expired');
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.NOT_IMPLEMENTED) {
        urls.navigateToUrl(process.env.contextRoot+'/not-supported');
        return;
    }
	urls.navigateToUrl(process.env.contextRoot+'/internal-problem');

}

module.exports = {
	ajaxGetJson : ajaxGetJson,
	ajaxPostJson: ajaxPostJson,
    handleError: handleError,
	errorHandler: errorHandler,
};




//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/services/ajaxHandler.js
// module id = CCE4
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16